export type MemberOptInResponse = {
  uuid: string
  isVerified: boolean
}

export type MemberMerchantDetailResponse = {
  contactEmail: string
  legalEntityNr: string
  legalName: string
}

export enum FailureMessage {
  OPERATION_ERROR = "OPERATION_ERROR",
}

export type ServiceFailedToReturn = {
  failureMessage?: FailureMessage
}
